const RichRelevanceBaseInstrumentationController = require('./rr-base-instrumentation-controller');

class RichRelevanceSearchInstrumentationController extends RichRelevanceBaseInstrumentationController {

    constructor($scope, $window, featureService, richRelevanceService, settings) {
        super($scope, $window, featureService, richRelevanceService);
        this.richRelevanceService = richRelevanceService;
        this.settings = settings;
        this.$window = $window;
    }

    sendInstrumentation() {
        // If we're requesting placements server-side, don't send the p13n call on Search.
        if (this.settings.richRelevance.removeDuplicatedProducts) {
            return;
        }
        this.richRelevanceService.getInformation()
            .then(() => {
                this.$window.R3_SEARCH = new this.$window.r3_search(); // eslint-disable-line new-cap
                this.$window.R3_SEARCH.setTerms(this.searchTerm);

                this.$window.rr_flush_onload();
                this.$window.r3();
            });
    }
}

const richRelevanceSearchInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', 'Settings', RichRelevanceSearchInstrumentationController],
    bindings: {
        searchTerm: '<',
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@',
    },
};

module.exports = {
    RichRelevanceSearchInstrumentationController,
    richRelevanceSearchInstrumentationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/richrelevance/instrumentation/rr-search-instrumentation.component.js